module.exports = __webpack_public_path__ + "img/icon-information-circle.9bee62fd.svg";